export enum RequestStatus {
	still = 'STILL',
	loading = 'LOADING',
	failed = 'FAILED',
}

export type ResponseStatus = 'Finished' | 'InProgress' | null;

export enum UrlAPI {
	// Authentication
	login = 'login',
	logout = 'logout',
	dictionaries = 'dictionaries',

	// Companies info
	companiesLookup = 'companiesLookup',

	// Company rating dashboard
	metaData = 'metadata',
	company = 'company',
	finalize = 'finalize',
	submit = 'submit',
	refresh = 'refresh',
	recommendation = 'recommendation',
}
